<template>
	<div class="fullscreen-btn" v-if="allowFullscreen" @click="toggle">
		<svg viewBox="0 0 31.277 31.377" xmlns="http://www.w3.org/2000/svg" v-bind:class="'container collapse'" v-if="fullscreen" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="#2a201b"><path d="M31.277 13.553l-14.554 1V0zM14.553 31.377l1-14.553H0z"/></g></svg>
		<svg viewBox="0 0 23.346 20.064" xmlns="http://www.w3.org/2000/svg" v-bind:class="'container expand'" v-else="" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="#2a201b"><path d="M21.346 14.553l2-14.553H6.793zM15.553 20.064L0 19.064 1 5.511z"/></g></svg>
	</div>
</template>

<script>
export default {
	name: 'FullScreen',
	computed: {
		allowFullscreen() {
			// Warning: Apple does not support fullscreen api so hide the fullscreen button
			const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
			if (iOS === false) {
				return true;
			}
			return false;
		},
	},
	data() {
		return {
			fullscreen: false,
		};
	},
	methods: {
		toggle() {
			this.$fullscreen.toggle();
			this.fullscreen = !this.fullscreen;
		},
	},
};
</script>

<style lang="scss" scoped>
	.fullscreen-btn {
		width: 25px;
		height: 25px;
		position: absolute;
		bottom: 2vmin;
		right: 15vmin;
		z-index: $z-top + 1;
		transform: scale(1);
		transition: all $ui-transition-duration-short;

		@include tablet {
			bottom: 2vmin;
			right: 10vmin;
		}

		@include desktop { display: none; }

		& .collapse { transform: translateY(-3px); } // to align with mute button
	}
</style>



// WEBPACK FOOTER //
// src/components/base/FullScreen.vue